import * as yup from 'yup';
import { fieldValidationMessages } from 'app/constants';
import { passwordPolicyDefaults } from 'app/components/SignUp/utils';
import { PasswordPolicy } from 'types/auth';

export const resetPasswordValidationSchema = ({
  minimumLength,
  maximumLength,
  pattern,
}: PasswordPolicy = passwordPolicyDefaults) =>
  yup.object().shape({
    token: yup.string().required(fieldValidationMessages.REQUIRED).length(6),
    password: yup
      .string()
      .required(fieldValidationMessages.REQUIRED_PASSWORD)
      .min(minimumLength, fieldValidationMessages.MIN_PASSWORD)
      .max(maximumLength, fieldValidationMessages.MAX_CHAR(maximumLength))
      .matches(new RegExp(pattern), fieldValidationMessages.WEAK_PASSWORD),
    passwordRepeat: yup
      .string()
      .required(fieldValidationMessages.REQUIRED_PASSWORD)
      .min(minimumLength, fieldValidationMessages.MIN_PASSWORD)
      .max(maximumLength, fieldValidationMessages.MAX_CHAR(maximumLength))
      .oneOf(
        [yup.ref('password'), null],
        "Those passwords didn't match, try again"
      ),
  });
